import React from 'react';

interface GradientBackgroundProps {
  children: React.ReactNode;
  className?: string;
}

const GradientBackground: React.FC<GradientBackgroundProps> = ({ children, className = '' }) => {
  return (
    <div className={`relative min-h-screen overflow-x-hidden ${className}`}>
      {/* 动态渐变背景 */}
      <div className="absolute inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 overflow-x-hidden">
        {/* 多层渐变叠加 */}
        <div className="absolute inset-0 bg-gradient-to-tr from-cyan-500/20 via-transparent to-purple-500/20 animate-pulse" />
        <div className="absolute inset-0 bg-gradient-to-bl from-pink-500/10 via-transparent to-blue-500/10" />

        {/* 动态光晕效果 */}
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-cyan-400/20 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-400/20 rounded-full blur-3xl animate-pulse delay-1000" />
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-pink-400/15 rounded-full blur-2xl animate-pulse delay-500" />
      </div>

      {/* 网格背景 */}
      <div
        className="absolute inset-0 opacity-20 overflow-x-hidden"
        style={{
          backgroundImage: `
            linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)
          `,
          backgroundSize: '50px 50px',
        }}
      />

      {/* 内容 */}
      <div className="relative z-10 overflow-x-hidden">{children}</div>
    </div>
  );
};

export default GradientBackground;
